<template>
  <BaseModal modal-id="modalAlert" :extendedModal="true" :show-modal="showModalActive" :allow-esc="bindEscKey">
    <template #heading>{{ modalDetails.header }}</template>
    <template #content>
      <div class="app-modal-basic">
        <img src="@ridmv/web-themes/images/icons/exclamation-triangle-solid.svg" alt="">
        <div class="message-ext">
          <p>Your session will expire in<span class="timeRemaining"> {{ formattedTime }} </span>seconds.</p>
          <p>{{ modalDetails.descriptionText }}</p>
        </div>
      </div>
    </template>
    <template #footing>
      <BaseButtonGroup>
        <template #default>
          <button @click.prevent="handleLogoutButton()">
            {{ modalDetails.logoutButtonText }}
          </button>
          <button class="app-btn-primary" @click.prevent="handleContinueSessionButton()">
            {{ modalDetails.continueSessionButtonText }}
          </button>
        </template>
      </BaseButtonGroup>
    </template>
  </BaseModal>
</template>
 

<script setup>
import { ref, watch, onUnmounted, computed } from 'vue';
import { useStore } from 'vuex';
import BaseModal from '@/components/ui/BaseModal';
import BaseButtonGroup from '@/components/ui/BaseButtonGroup';
import * as COMMONS from '../../store/_commons';

const props = defineProps({
  showModalActive: Boolean,
  onTimeout: Function,
});

const emit = defineEmits(['getShowStatus']);

// Vuex store
const store = useStore();

const bindEscKey = ref(false);
const modalDetails = {
  header: 'Your session is about to expire.',
  descriptionText: "To continue, please click on 'Continue Session' or click 'Log Out' to end your session immediately.",
  continueSessionButtonText: 'Continue Session',
  logoutButtonText: 'Log Out',
  modalType: 'expired',
};
const timeRemaining = ref(60);
const timerId = ref(0);

const formattedTime = computed(() => {
  const seconds = timeRemaining.value;
  return seconds < 10 ? `0${seconds}` : String(seconds); 
});

// Watcher
watch(
  () => props.showModalActive,
  (newValue) => {
    if (newValue) {
      timeRemaining.value = 60; 
      startTimer();
    } else {
      clearInterval(timerId.value); 
      timeRemaining.value = 60;
    }
  }
);

// Methods 
const handleContinueSessionButton = () => {
  clearInterval(timerId.value);
  store.dispatch(COMMONS.GUEST_LOGIN_EXTEND_LOGIN);
  emit('getShowStatus', false);
  timeRemaining.value = 60;
};

const handleLogoutButton = () => {
  if (!props.showModalActive) return;
  store.dispatch(COMMONS.GUEST_LOGIN_GET_LOGOUT);
  emit('getShowStatus', false);
};

const startTimer = () => {
  // Clear any existing interval before starting a new one
  clearInterval(timerId.value); 

  timerId.value = setInterval(() => {
    if (props.showModalActive) {
      // Decrement the time every second
      timeRemaining.value -= 1;
      
      if (timeRemaining.value === 0) {
        clearInterval(timerId.value);
        if (props.onTimeout) {
            props.onTimeout(); 
        }
      }
      
    } else {
      // If modal is suddenly hidden or already zero, stop the interval
      clearInterval(timerId.value);
    }
  }, 1000);
};

// Lifecycle hook for cleanup
onUnmounted(() => {
  clearInterval(timerId.value);
});

defineExpose({
startTimer
});
</script>


<style lang="scss" scoped>
// TODO: should have been picked up from @ridmv/web-themes but it's not...
.app-modal-basic {
  display: flex;
  align-items: flex-start;
  img {
    margin: 0.7em 0.5em 0 0;
    width: 1.25rem;
  }

  .message-ext {
  p {
    color: black;
  }}
  .timeRemaining {
    display: inline-block;
    width: 30px;
    text-align: center;
    @extend %font-sans-bold;
    font-size: 1.25rem;
  }
}
button {
  margin-bottom: 1.125em;
  &:not(:last-child) {
    margin-right: 1em;
  }
  &.disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
}
</style>
  